(function ($, Drupal) {
  Drupal.behaviors.paragraph_tabs = {
    attach: function (context, settings) {
      $(once('hide', '.paragraph--tabs .paragraph--tab .tab__content')).hide();

      $(once('tab-click', '.paragraph--tabs .paragraph--tab')).each(function(e){
        $(this).find('.tab__header').click(function(e){
          e.preventDefault();
          $(this).parents('.paragraph--tab').toggleClass('open').find('.tab__content').slideToggle({
            progress: function() {
              Drupal.behaviors.overlapping_backgrounds.callPBackgroundsSize();
            }
          });
        });

        if($(this).index() === 0){
          $(this).addClass('open').find('.tab__content').show();
        }
      });

      Drupal.behaviors.overlapping_backgrounds.callPBackgroundsSize();
    },
  };
})(jQuery, Drupal);
